module.exports = __webpack_public_path__ + "static/media/rd_name_nav.430d5cd3.svg";